<script>
import { mapActions, mapGetters } from 'vuex'
import AppModalNotificacao from '@/screens/portal/seguranca/components/AppModalNotificacao'
import layoutPage from '@/components(new)/layout/LayoutBases/LayoutCentral/LayoutCentral.vue'

export default {
  components: {
    AppModalNotificacao,
    layoutPage
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  data () {
    return {
      modulos: [],
      perfis: [],
      loading: false,
      notification: null,
      notificacoes: [],
      index: 0,
      tokenExibido: false
    }
  },

  async created () {
    this.modulos = await this.findModulosUsuario(this.usuario.id)
    // this.notificacoes = await this.getMessageNotification(this.usuario.id)
    // this.atualizaNotificacao()
  },

  methods: {
    ...mapActions({
      getToken: 'auth/getToken',
      selecioneModulo: 'auth/selecioneModulo',
      selecionePerfil: 'auth/selecionePerfil',
      findModulosUsuario: 'usuario/findModulosUsuario',
      findPerfisUsuario: 'usuario/findPerfisUsuario',
      getMessageNotification: 'notifications/getMessageNotification',
      getArcGis: 'arcgis/getArcGis',
      getArcGisMonitoramentoClausulas: 'arcgis/getArcGisMonitoramentoClausulas',
      getUrlInventarioPatrimonialArcGis: 'arcgis/getUrlInventarioPatrimonialArcGis'
    }),

    atualizaNotificacao () {
      this.notification = null
      const notificacoesToken = this.notificacoes.filter(notification => notification.typeNotification === 'TOKEN')
      const notificacoesOutros = this.notificacoes.filter(notification => notification.typeNotification !== 'TOKEN')
      if (notificacoesToken.length && !this.tokenExibido) {
        const notificacaoMaisRecente = notificacoesToken
          .map(notification => ({
            ...notification,
            difference: Math.abs(new Date(notification.dtAlteracaoNotificacao) - new Date())
          }))
          .sort((a, b) => a.difference - b.difference)[0]
        this.notification = notificacaoMaisRecente

        this.tokenExibido = true
      }
      if (this.index < notificacoesOutros.length) {
        this.notification = notificacoesOutros[this.index]
        this.index++
      }
    },

    async closeModal () {
      this.atualizaNotificacao()
    },

    async setModulo (modulo) {
      this.loading = true
      try {
        await this.selecioneModulo({ moduloId: modulo.id })

        this.perfis = await this.findPerfisUsuario({ idUsuario: this.usuario.id, idModulo: this.usuario.moduloSelecionado.id })
        if (this.perfis && this.perfis.length > 1) {
          this.$router.push({
            name: 'selecionarPerfil'
          })
        } else if (this.perfis && this.perfis.length === 1) {
          await this.selecionePerfil({ moduloId: this.usuario.moduloSelecionado.id, perfilId: this.perfis[0].id })
          this.$router.push({
            name: this.perfis[0].paginaInicial
          })
        } else {
          this.$router.push({
            name: modulo.url
          })
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },

    imgModulo (modulo) {
      return 'static/modulos/' + modulo?.codigo?.toLowerCase() + '.png'
    }
  }
}
</script>

<template>
   <layoutPage>
      <div class="text-center">
        <app-modal-notificacao
          v-if="notification"
          :idUsuario="usuario.id"
          :notificacao="notification"
          @closeModal="closeModal()"
        />

        <main class="container" v-loading="loading">
          <el-row
            class="container"
            type="flex"
            justify="center"
            :gutter="20"
            v-if="usuario"
          >
            <p class="text-center" v-if="modulos && modulos.length > 0">
              Clique sobre o botão correspondente ao módulo que deseja no sistema:
            </p>
            <p class="text-center" v-else>
              Este usuário não possui acesso a nenhum módulo do sistema.
            </p>
          </el-row>

          <el-row
            class="container"
            type="flex"
            justify="center"
            :gutter="20"
            v-if="usuario"
          >
            <el-col
              v-for="modulo in [...modulos].sort((a, b) => (a.nome > b.nome ? 1 : -1))"
              :key="modulo.id"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              :xl="4"
            >
              <div class="card" @click="setModulo(modulo)">
                <el-card>
                  <template v-slot:header>
                    <img class="perfil" :src="imgModulo(modulo)" />
                  </template>
                  <div>
                    <span>{{ modulo.nome }}</span>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </main>
      </div>
  </layoutPage>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/selecionar-modulo/selecionar-modulo.vue